import React from 'react';
import classNames from 'classnames';
import { ImageSlider } from 'ncoded-component-library';
import ResolveImage from 'components/ResolveImage';
import { getImgUrl } from 'components/ResolveImage/utils';
import { getHasElementsInArray } from 'utils';
import { DropzoneFile } from 'components/Dropzone/utils';

import './PremiumListingGallery.styles.scss';

type PremiumListingGalleryProps = {
  className?: string;
  gallery: DropzoneFile[] | null;
  onImagePress?: () => void;
};

const PremiumListingGallery: React.FC<PremiumListingGalleryProps> = (
  props,
) => {
  const { className, gallery, onImagePress } = props;

  const classes = classNames('premium-listing-gallery', className);

  return (
    <div className={classes}>
      {gallery?.length > 1 ? (
        <ImageSlider
          onImagePress={onImagePress}
          slides={gallery.map(({ url }) => ({
            imageUrl: getImgUrl(url, '480'),
          }))}
          showDots={getHasElementsInArray(gallery)}
        />
      ) : (
        <ResolveImage
          src={getImgUrl(gallery?.[0]?.url, '480')}
          shouldLazyLoad={false}
        />
      )}
    </div>
  );
};

export default PremiumListingGallery;
